import formularusVerlag from './formularus_verlag.svg';

export default {
  formularusVerlag,
};
